import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'src/components'
import { Columns } from 'src/components/layout'
import { Icon, TimesIcon } from 'src/components/icons'
import styles from './ErrorTooltip.scss'

/**
 * Displays a tooltip error
 */
const ErrorTooltip = ({ error, visible, icon, color, disabled, ...props }) => (
  <Tooltip
    title={
      <Columns align="center">
        <Icon icon={icon} fixedWidth color={color} size="lg" />
        <span>{error}</span>
      </Columns>
    }
    visible={error && visible}
    disabled={!error || disabled}
    popperProps={{ placement: 'top' }}
    className={error && styles.error}
    {...props}
  ></Tooltip>
)

ErrorTooltip.defaultProps = {
  icon: TimesIcon,
  color: 'danger',
}

ErrorTooltip.propTypes = {
  /**
   * The error to display.
   */
  error: PropTypes.node,
  /**
   * Whether the error is visible.
   */
  visible: PropTypes.bool,
  /**
   * Whether the tooltip is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * The error icon.
   */
  icon: PropTypes.elementType,
  /**
   * The icon color.
   */
  color: PropTypes.string,
}

export default ErrorTooltip
